import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { getConsentStatus } from './utils/cookieConsent';

// Injecting Cookie3 script if cookies accepted into <head> as per their instructions
if (getConsentStatus() === 'granted') {
  const script = document.createElement('script');
  script.src =
    'https://cdn.markfi.xyz/scripts/analytics/0.11.24/cookie3.analytics.min.js';
  script.integrity =
    'sha384-ihnQ09PGDbDPthGB3QoQ2Heg2RwQIDyWkHkqxMzq91RPeP8OmydAZbQLgAakAOfI';
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.setAttribute('site-id', '1168bd3c-c885-4c53-a24e-973a2e70dd5b');
  script.setAttribute('strategy', 'lazyOnload');
  document.head.appendChild(script);
}

// @ts-ignore
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
